module.exports = __webpack_public_path__ + "05f49439beae7a2c5d4b21240f9bb7ec.fbx";